import { useEffect, useRef, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * Lee un documento CMS con fallback a datos estáticos (JSON).
 */
export function useCmsDoc(collectionName, docId, fallback = null) {
  const fallbackRef = useRef(fallback);
  fallbackRef.current = fallback;

  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [source, setSource] = useState("fallback");
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const snap = await getDoc(doc(db, collectionName, docId));
        if (cancelled) return;
        if (snap.exists()) {
          setData({ id: snap.id, ...snap.data() });
          setSource("firestore");
        } else {
          setData(fallbackRef.current);
          setSource("fallback");
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setData(fallbackRef.current);
          setSource("fallback");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [collectionName, docId]);

  return { data, loading, source, error };
}
